import React from 'react';

const SvgTriangleLegend = (props) => (
  <svg width={20} height={10} {...props}>
    <g fill="none">
      <rect width={20} height={1} y={5.5} fill={props.color} rx={0.5} />
      <path
        fill="#FFF"
        stroke={props.color}
        strokeWidth={2}
        d="M10.376 2.236L6.963 9h6.764l-3.351-6.764z"
      />
    </g>
  </svg>
);

export default SvgTriangleLegend;
